<template>
    <div class="full-wdith-editor">
        <div class="editor-title-toolbar">
            <ReturnButton
                class="return-btn"
                @click="clickReturnBtn"
                v-show="showReturnBtn !== null && showReturnBtn !== false"
                :label="returnLabel"
            />

            <div>
                <h2 tkey="產品管理">{{i18n.tkey("lang_product_manager")}}</h2>
            </div>

            <div class="right-operation-btn">
<!--                <el-button type="primary" @click="goAddItem" tkey="添加產品">{{i18n.tkey("lang_add_product")}}</el-button>-->
                &nbsp;
            </div>
        </div>

        <JoinHallItemRecord @goEdit="goEditItem" v-if="viewPart === 'list'" />

        <InsertOrEditJoinHallMaterial :editObj="editObj" v-if="viewPart === 'edit'" />
    </div>
</template>

<script setup>

import InsertOrEditJoinHallMaterial from "@/components/shopopee/hall/insertOrEditJoinHallMaterial.vue";
import JoinHallItemRecord from "@/components/shopopee/hall/joinHallItemRecord.vue";
import ReturnButton from "@/components/shopopee/common/returnButton.vue";
import {inject, ref, computed} from "vue";


const props = defineProps(["showReturnBtn"])
const emits = defineEmits(["clickReturnBtn"])

const i18n = inject("i18n")

const viewPart = ref("list")
const editObj = ref(null)

const returnLabel = computed(() => {
    let text = i18n.tkey("lang_return")

    if (viewPart.value === "edit"){
        text = i18n.tkey("lang_return")
    }

    return text

})

function goAddItem(){
    viewPart.value = "edit"
}

function goEditItem(item){
    editObj.value = item
    viewPart.value = "edit"
}

function clickReturnBtn(){
    if (viewPart.value === "edit"){
        viewPart.value = "list"
        editObj.value = null
    }else{
        emits("clickReturnBtn")
    }

}

</script>

<style scoped>
    .full-wdith-editor {
        width: 100%;
    }

    .editor-title-toolbar {
        text-align: center;
        position: relative;
        margin-bottom: 32px;
    }

    .editor-title-toolbar .return-btn {
        position: absolute;
        left: 0;
        top: 5px;
    }

    .editor-title-toolbar .right-operation-btn {
        position: absolute;
        right: 0;
        top: 0;
    }

</style>